



























import { computed, defineComponent, nextTick, onMounted, PropType, ref } from "@vue/composition-api";
import { formatDate } from "@/lib/time";
import { FormFields } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "AiQuestionaryBlock",
  components: { BaseIconButton, BaseButton, BaseIcon },
  props: {
    fields: { type: Array as PropType<FormFields>, required: true },
    values: { type: Object as PropType<Record<string, string>> },
  },
  setup(props) {
    const showAllRows = ref(false);
    const showMoreButton = ref(false);

    const items = ref<HTMLElement[]>();
    const title = computed(() => props.fields.find(i => i.name === "title")?.label ?? "");
    const records = computed(() =>
      props.fields
        .filter(i => i.name !== "title")
        .map(i => {
          let value = props.values ? props.values[i.name] ?? "" : "";
          if (i.type == "date" && value) {
            value = formatDate(new Date(value), { month: "long", day: "numeric", year: "numeric" });
          }
          return { text: i.label, value };
        })
        .filter(i => !!i.value)
    );

    const calculateVisibleRows = async () => {
      if (!items.value) return;
      let halfRowCount = 0;
      for (const element of items.value) {
        element.classList.remove("hidden", "__full-width");

        halfRowCount++;
        if (element.scrollHeight > 37) {
          element.classList.add("__full-width");
          halfRowCount++;
        }
        if (!showAllRows.value && halfRowCount > 6) {
          element.classList.add("hidden");
        }
        await nextTick();
      }
      if (!showAllRows.value && halfRowCount > 6) {
        showMoreButton.value = true;
      }
    };

    const onShowMore = async () => {
      showAllRows.value = true;
      showMoreButton.value = false;
      calculateVisibleRows().then();
    };

    onMounted(() => calculateVisibleRows());

    return {
      title,
      records,
      items,
      showAllRows,
      showMoreButton,
      onShowMore,
    };
  },
});
